var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9098 18.8052C31.2917 19.0861 30.6737 19.2547 29.9432 19.367C30.6175 18.9175 31.1794 18.2995 31.4603 17.5128C30.7861 17.9062 30.0556 18.1871 29.3252 18.3557C28.7071 17.6814 27.8081 17.2881 26.8529 17.2881C24.9987 17.2881 23.4255 18.8052 23.4255 20.7155C23.4255 20.9965 23.4816 21.2212 23.5378 21.5022C20.7284 21.3898 18.2 19.9851 16.5144 17.9623C16.2334 18.3557 16.0649 18.9175 16.0649 19.5356C16.0649 20.7155 16.6829 21.7831 17.5819 22.345C17.02 22.345 16.5144 22.1764 16.0649 21.8955V21.9517C16.0649 23.5811 17.2448 24.9858 18.8181 25.2667C18.5371 25.3229 18.2562 25.3791 17.919 25.3791C17.6943 25.3791 17.4695 25.3791 17.301 25.3229C17.7505 26.6714 18.9866 27.6828 20.5037 27.6828C19.3237 28.5818 17.8629 29.1437 16.2896 29.1437C16.0087 29.1437 15.7277 29.1437 15.503 29.0875C16.8515 30.1551 18.6495 30.717 20.5599 30.717C26.7967 30.717 30.2242 25.5477 30.2242 21.0527V20.6032C30.8984 20.0975 31.4603 19.5356 31.9098 18.8052Z",
    fill: "#171717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/Footer-Twitter.cb4bba6764dd28ee9dc6cb45ab947b4c.svg";
export { ForwardRef as ReactComponent };